module.exports = wp["blocks"];